import { computed, ref, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.regexp.flags.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d78a7ab"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "app-name overflow-ellipsis"
};
const _hoisted_3 = {
  class: "app-name overflow-ellipsis"
};
const _hoisted_4 = {
  key: 0,
  class: "pay-channel-content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 6,
  class: "handle-content"
};
const _hoisted_8 = {
  key: 8
};
import { getPubStatusProperty } from '../hooks/pubStatus';
import { getSubscriptionProperty } from '../hooks/includeSubscriptionStatus';
import IconCopy from '@/components/IconCopy.vue';
import { queryCommonConfig } from '@/api/payManage/appManage';
import RecordModal from '@/views/payManage/newAccountManage/components/RecordModal.vue';
import CommonModal from '@/views/payManage/appManage/components/CommonModal.vue';
import { OK } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppTableBlock',
  props: {
    dataSource: {
      type: Array,
      default: () => []
    }
  },
  emits: ['showChannel', 'refresh'],
  setup(__props, {
    emit
  }) {
    const columns = [{
      title: '产品ID',
      dataIndex: 'dbtId',
      key: 'dbtId',
      fixed: 'left'
    }, {
      title: '产品名',
      dataIndex: 'appName',
      key: 'appName'
    }, {
      title: '商店名',
      dataIndex: 'storeName',
      key: 'storeName'
    }, {
      title: '状态',
      dataIndex: 'pubStatus',
      key: 'pubStatus'
    }, {
      title: '工作室',
      dataIndex: 'studio',
      key: 'studio'
    }, {
      title: '主体/账号',
      dataIndex: 'mchAccountName',
      key: 'mchAccountName'
    }, {
      title: '市场',
      dataIndex: 'publishPlatformName',
      key: 'publishPlatformName'
    }, {
      title: '是否有订阅',
      dataIndex: 'includeSubscriptionFunction',
      key: 'includeSubscriptionFunction'
    }, {
      title: '在线渠道',
      dataIndex: 'payChannel',
      key: 'payChannel',
      width: 600
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right',
      width: 80
    }];
    const channelClass = {
      google: 'google',
      apple: 'ios',
      vivo: 'ios',
      wechat: 'wechat',
      wxpay: 'wechat',
      jsapipay: 'wechat',
      wxminigame: 'wechat',
      wxnativepay: 'wechat',
      wxpaynative: 'wechat',
      amazon: 'amazon',
      alipay: 'alipay',
      alipay_web: 'alipay',
      aliminigame: 'alipay',
      huawei: 'huawei',
      harmony: 'huawei',
      huawei_foreign: 'huawei',
      huawei_mg: 'huawei',
      huawei_runtime_fastgame: 'huawei',
      douyinMiniGame: 'douyin',
      douyingame: 'douyin',
      douyinOrdinaryMiniGame: 'douyin',
      ksminigame: 'ksminigame',
      ksiosminigame: 'ksminigame',
      xiaomi: 'xiaomi',
      oppo: 'oppo',
      tap: 'tap'
    };
    const routeName = computed(() => useRoute().name);
    const tableRef = ref(),
      commonVisible = ref(false),
      commonEdit = ref({}),
      editItem = ref({}),
      detailRef = ref(null),
      recordModalRef = ref(),
      // 详情-变更记录弹窗开关
      openCommon = async item => {
        try {
          const {
            data,
            code
          } = await queryCommonConfig({
            dbtId: item.dbtId
          }).catch(e => {});
          if (code === OK) {
            commonVisible.value = true;
            commonEdit.value = {
              ...item,
              notifyUrl: data === null || data === void 0 ? void 0 : data.notifyUrl,
              strongNetworkingKey: data === null || data === void 0 ? void 0 : data.strongNetworkingKey
            };
          }
        } catch (e) {}
      };
    const getHasInternalPurchaseFlags = chnlInfo => {
      var _chnlInfo$flags$filte, _chnlInfo$flags;
      return (_chnlInfo$flags$filte = chnlInfo === null || chnlInfo === void 0 || (_chnlInfo$flags = chnlInfo.flags) === null || _chnlInfo$flags === void 0 ? void 0 : _chnlInfo$flags.filter(item => item.hasInternalPurchase)) !== null && _chnlInfo$flags$filte !== void 0 ? _chnlInfo$flags$filte : [];
    };
    const getChannelColor = channel => {
      const colorMap = {
        google: {
          background: 'rgba(255, 233, 217, 1)',
          color: '#000000a6'
        },
        ios: {
          background: 'rgba(230, 241, 255, 1)',
          color: '#000000a6'
        },
        wechat: {
          background: 'rgba(232, 248, 235, 1)',
          color: '#000000a6'
        },
        alipay: {
          background: 'rgba(230, 246, 255, 1)',
          color: '#000000a6'
        },
        huawei: {
          background: 'rgba(255, 219, 217, 1)',
          color: '#000000a6'
        },
        douyin: {
          background: 'rgba(255, 217, 242, 1)',
          color: '#000000a6'
        },
        ksminigame: {
          background: 'rgba(255, 210, 180, 1)',
          color: '#000000a6'
        },
        xiaomi: {
          background: 'rgba(255, 235, 217, 1)',
          color: '#000000a6'
        },
        oppo: {
          background: 'rgba(201, 242, 255, 1)',
          color: '#000000a6'
        },
        amazon: {
          background: 'rgba(255, 246, 217, 1)',
          color: '#000000a6'
        },
        tap: {
          background: 'rgba(255, 246, 207, 1)',
          color: '#000000a6'
        },
        other: {
          background: 'rgba(255, 250, 220, 1)',
          color: '#000000a6' // 字体色统一
        }
      };
      if (colorMap[channel]) {
        return colorMap[channel];
      }
      // 未定义渠道，随机选一个已有渠道
      const keys = Object.keys(colorMap);
      const randomKey = keys[Math.floor(Math.random() * keys.length)];
      return colorMap[randomKey];
    };
    const openRecordDetail = async (item, type) => {
      editItem.value = item;
      nextTick(() => {
        recordModalRef.value.openModal('account');
      });
    };
    // 返回整个 style 对象
    const getChannelStyle = chnlFlag => {
      return getChannelColor(channelClass[chnlFlag]);
    };
    const showChannelList = (item, record) => {
      emit('showChannel', item, record);
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": __props.dataSource,
        "row-key": "dbtId",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        scroll: {
          x: 'max-content'
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _getHasInternalPurcha;
          return [column.dataIndex === 'dbtId' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(IconCopy, {
            copyValue: record.dbtId,
            copyIconName: "productIDIcon",
            copyIconGreyName: "productIDGreyIcon"
          }, null, 8, ["copyValue"]), _createVNode(IconCopy, {
            copyValue: record.appId,
            copyIconName: "appIdIcon",
            copyIconGreyName: "appIdGreyIcon"
          }, null, 8, ["copyValue"])], 64)) : column.dataIndex === 'appName' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1,
            title: record.appName,
            placement: "topLeft"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(record.appName), 1)]),
            _: 2
          }, 1032, ["title"])) : column.dataIndex === 'storeName' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2,
            title: record.storeName,
            placement: "topLeft"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record.storeName || '--'), 1)]),
            _: 2
          }, 1032, ["title"])) : column.dataIndex === 'pubStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["app-status", _unref(getPubStatusProperty)(record.pubStatus, 'classTagName')])
          }, _toDisplayString(_unref(getPubStatusProperty)(record.pubStatus, 'label') || '--'), 3)) : column.dataIndex === 'includeSubscriptionFunction' ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["app-status", _unref(getSubscriptionProperty)(record.includeSubscriptionFunction, 'classTagName')])
          }, _toDisplayString(_unref(getSubscriptionProperty)(record.includeSubscriptionFunction, 'label') || '--'), 3)) : column.dataIndex === 'payChannel' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [(_getHasInternalPurcha = getHasInternalPurchaseFlags(record === null || record === void 0 ? void 0 : record.chnlInfo)) !== null && _getHasInternalPurcha !== void 0 && _getHasInternalPurcha.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHasInternalPurchaseFlags(record.chnlInfo), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.chnlFlag,
              onClick: $event => showChannelList(item.chnlFlag, record),
              class: "pay-channel-block",
              style: _normalizeStyle(getChannelStyle(item.chnlFlag))
            }, _toDisplayString(item.channelName || '其他'), 13, _hoisted_5);
          }), 128))])) : (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: $event => showChannelList('', record)
          }, "--", 8, _hoisted_6))], 64)) : column.dataIndex === 'handle' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openCommon(record)
          }, {
            default: _withCtx(() => [_createTextVNode("通用配置")]),
            _: 2
          }, 1032, ["onClick"])])), [[_directive_permission, {
            permissionValue: _unref(routeName),
            btnType: 'update'
          }]]) : column.dataIndex === 'mchAccountName' ? (_openBlock(), _createBlock(_component_a_button, {
            key: 7,
            type: "link",
            onClick: $event => openRecordDetail(record, 'account')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(record.mchAccountName), 1)]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record[column.dataIndex] || '--'), 1))];
        }),
        _: 1
      }, 8, ["data-source"]), _createVNode(CommonModal, {
        "modal-visible": commonVisible.value,
        "onUpdate:modal-visible": _cache[0] || (_cache[0] = $event => commonVisible.value = $event),
        "edit-item": commonEdit.value
      }, null, 8, ["modal-visible", "edit-item"]), _createVNode(RecordModal, {
        ref_key: "recordModalRef",
        ref: recordModalRef,
        currentRow: editItem.value
      }, null, 8, ["currentRow"])]);
    };
  }
});